import styled from 'styled-components';

export const Container = styled.div`
  background: #0000ff;
  background: #fff;
  transition: background-color 180ms ease-out;
  font-size: 1.4em;

  .conertTime {
    text-transform: uppercase;
    margin-right: 50px;
    color: #000;
    font-family: 'GT America';
    font-size: 0.75em;
    flex-shrink: 0;
    min-width: 70px;
  }

  .left {
    display: flex;
    flex-direction: row;
    flex: 1;
    padding-right: 15px;
    max-width: 850px;
  }

  .venue {
    text-transform: uppercase;
    font-family: 'GT America';
    font-weight: 500;
    font-style: normal;
    font-size: 0.75em;
    line-height: 1.4;
    color: #000;
  }

  .details {
    display: flex;
    flex-direction: column;
    position: relative;
    top: -2px;
  }

  .buttonWrapper {
  }

  .buy {
    box-sizing: border-box;
    padding: 10px 10px 10px 12px;
    text-decoration: none;
    margin-left: 10px;
    text-transform: uppercase;
    font-family: 'GT America';
    font-size: 0.6em;
    background: #000;
    align-self: flex-start;
    background: #fff;
    color: #000;
    border: 1px solid #000;
    transition: all 110ms ease-out;
    &:hover {
      color: #fff;
      background: #000;
    }

    &:first-child {
      margin-left: 0;
    }
  }

  .acts {
    display: flex;
    margin-top: 10px;
    font-family: 'GT America';
    font-weight: 300;
    flex-wrap: wrap;
    text-transform: uppercase;
    font-size: 0.55em;
    color: #f922ab;
    span {
      margin-right: 7px;
    }
    @media (max-width: 600px) {
      font-size: 0.55em;
    }
  }

  @media (max-width: 600px) {
    .conertTime {
      margin-bottom: 15px;
    }

    .left {
      flex-direction: column;
    }

    .buttonWrapper {
      margin-top: 20px;
    }
  }

  &:hover {
    background-color: #fff;
  }
`;

export const Box = styled.div`
  display: flex;
  justify-content: space-between;
  max-width: 1180px;
  width: 100%;
  margin: 0 auto;
  padding: 25px 30px;
  box-sizing: border-box;
  border-bottom: 1px solid #0000ff;

  &:last-child {
    border-bottom: none;
  }

  @media (max-width: 600px) {
    flex-direction: column;
  }
`;
